import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { HandleAjaxError, ShowErrorFlag } from '@helpcenter/flags';
import { HANDLE_AJAX_ERROR, showErrorFlag } from '@helpcenter/flags';
import { getDefaultError } from 'utils/errors';

export const handleAjaxErrorEpic: Epic<HandleAjaxError, ShowErrorFlag> = (action$) => {
	return action$.ofType(HANDLE_AJAX_ERROR).mergeMap((handleAjaxErrorAction) => {
		const { error } = handleAjaxErrorAction.payload;
		// TODO: Handle errors that come directly from the backend already translated (https://jdog.jira-dev.com/browse/JNW-236)
		const errorDescriptor = getDefaultError(error);
		const genericAction =
			errorDescriptor.action === undefined ? undefined : [errorDescriptor.action];
		const errorFlagAction = showErrorFlag(
			errorDescriptor.title,
			errorDescriptor.description,
			genericAction,
		);
		return Observable.of(errorFlagAction);
	});
};
